export const averagePriceConstants = {
	Calculation: {
		SUCCESS : 'CALCULATE_AVERAGE_PRICE_SUCCESS',
		REQUEST : 'CALCULATE_AVERAGE_PRICE_REQUEST',
		FAILURE : 'CALCULATE_AVERAGE_PRICE_FAILURE'
	},
	CalculationFile: {
		SUCCESS : 'CALCULATE_AVERAGE_PRICE_FILE_SUCCESS',
		REQUEST : 'CALCULATE_AVERAGE_PRICE_FILE_REQUEST',
		FAILURE : 'CALCULATE_AVERAGE_PRICE_FILE_FAILURE'
	},
	GetPreliminaryCalculationFile: {
		SUCCESS : 'GET_PRELIMINARY_AVERAGE_PRICE_FILE_SUCCESS',
		REQUEST : 'GET_PRELIMINARY_AVERAGE_PRICE_FILE_REQUEST',
		FAILURE : 'GET_PRELIMINARY_AVERAGE_PRICE_FILE_FAILURE'
	},
	PreliminaryCalculation: {
		SUCCESS : 'PRELIMINARY_CALCULATION_AVERAGE_PRICE_SUCCESS',
		REQUEST : 'PRELIMINARY_CALCULATION_AVERAGE_PRICE_REQUEST',
		FAILURE : 'PRELIMINARY_CALCULATION_AVERAGE_PRICE_FAILURE'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_AVERAGE_PRICE_SUCCESS',
		REQUEST : 'GET_PAGED_AVERAGE_PRICE_REQUEST',
		FAILURE : 'GET_PAGED_AVERAGE_PRICE_FAILURE'
	},
	GetPreliminaryCalculationPaged: {
		SUCCESS : 'GET_PRELIMINARY_CALCULATION_AVERAGE_PRICE_PAGED_SUCCESS',
		REQUEST : 'GET_PRELIMINARY_CALCULATION_AVERAGE_PRICE_PAGED_REQUEST',
		FAILURE : 'GET_PRELIMINARY_CALCULATION_AVERAGE_PRICE_PAGED_FAILURE'
	},
	GetFile: {
		SUCCESS : 'GET_FILE_AVERAGE_PRICE_SUCCESS',
		REQUEST : 'GET_FILE_AVERAGE_PRICE_REQUEST',
		FAILURE : 'GET_FILE_AVERAGE_PRICE_FAILURE'
	},
	PublishPrices: {
		SUCCESS : 'PUBLISH_AVERAGE_PRICES_SUCCESS',
		REQUEST : 'PUBLISH_AVERAGE_PRICES_REQUEST',
		FAILURE : 'PUBLISH_AVERAGE_PRICES_FAILURE'
	},
	Delete: {
		SUCCESS : 'DELETE_CALCULATION_AVERAGE_PRICE_SUCCESS',
		REQUEST : 'DELETE_CALCULATION_AVERAGE_PRICE_REQUEST',
		FAILURE : 'DELETE_CALCULATION_AVERAGE_PRICE_FAILURE'
	},
	CLEAR         : 'CLEAR_AVERAGE_PRICE',
	CLEAR_MESSAGE : 'CLEAR_AVERAGE_PRICE_MESSAGE'
}